module.exports = __webpack_public_path__ + "open-sans-latin-700italic.f445cf25b8e059587318.svg";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-700italic.svg
// module id = ../../../../typeface-open-sans/files/open-sans-latin-700italic.svg
// module chunks = 1 3